import keyMirror from "key-mirror";

export const INPUT_TYPES = keyMirror({
    AUTOCOMPLETE: null,
    SEARCH: null,
    TEXT: null,
    NUMBER: null,
    TIME: null,
    EMAIL: null,
    TEXTAREA: null,
    DATE: null,
    DATE_MONTH: null,
    PASSWORD: null,
    SELECT: null,
    RADIO: null,
    CHECKBOX: null,
    TILES: null,
    FLOAT: null,
    OBJECT_TEXT: null,
    OBJECT_SELECT: null,
    MULTI_TABLE_SELECT: null,
    FILE: null,
    DATE_RANGE: null,
    NUMBER_RANGE: null,
    TABLE: null,
    DRAGGABLEUPLOADER: null,
    DAYS_CALCULATOR: null,
    DISPLAY_NONE: null,
    TABLE_EDITOR: null,
    BUTTON: null
});
